import gql from 'graphql-tag';

export default gql `
query singleUser($id: ID!){
    singleUser(id: $id) {
            		id
					username
					email
					name
					goals
					voicePursuit
					gender
					Age
					voiceType
					voiceDescriptives
        	
    }
}`;


// WEBPACK FOOTER //
// ./src/components/queries/SingleUserQuery.js